module.exports = __webpack_public_path__ + "img/stp.b833e628.png";